import { Component } from "react";

import _ from "underscore";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

class BorrowerTerms extends Component {
  constructor(props) {
    super(props);

    this.state = { editorState: EditorState.createEmpty() };
  }

  UNSAFE_componentWillMount() {
    this.props.getBorrowerTerms();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.terms.borrowerTerms.fetching &&
      !nextProps.terms.borrowerTerms.fetching
    ) {
      this.buildContentState(nextProps.terms.borrowerTerms);
    }
  }

  buildContentState(props) {
    const lastSortedTerms = _.sortBy(props.data, (terms) => {
      return terms.Version;
    });

    const blocksFromHtml = htmlToDraft(lastSortedTerms.at(-1).Content);
    const contentBlocks = blocksFromHtml.contentBlocks;
    const contentState = ContentState.createFromBlockArray(contentBlocks);
    const editorState = EditorState.createWithContent(contentState);

    this.setState({
      editorState,
      version: lastSortedTerms.at(-1).Version,
    });
  }

  sendNewVersion = (ignoreVersioning) => {
    const content = this.state.editorState.getCurrentContent();
    const rawContent = convertToRaw(content);

    const raw = draftToHtml(rawContent);

    if (ignoreVersioning) {
      // eslint-disable-next-line no-console
      console.log(this.state.version, "version");
      this.props.sendNewBorrowerTerms(raw, this.state.version, true);
    } else this.props.sendNewBorrowerTerms(raw, this.state.version);
  };

  changeVersion = (event) => {
    this.setState({
      ...this.state,
      version: event.target.value,
    });
  };

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
  };

  render() {
    return (
      <div
        style={{
          padding: "6px 5px 0",
          borderRadius: "2px",
          border: "1px solid #F1F1F1",
          background: "white",
        }}
      >
        <input
          type="text"
          value={this.state.version}
          onChange={this.changeVersion}
        />
        <input
          type="button"
          value="Send terms"
          onClick={this.sendNewVersion.bind(this, false)}
        />
        <input
          style={{ float: "right" }}
          type="button"
          value="Send terms without versioning"
          onClick={this.sendNewVersion.bind(this, true)}
        />
        <Editor
          editorState={this.state.editorState}
          onEditorStateChange={this.onEditorStateChange}
        />
      </div>
    );
  }
}
export default BorrowerTerms;
